<template>
    <div class="picDetail">
        <div class="title">
            <h3>活动印花</h3>
            <el-breadcrumb class="fl" separator-class="el-icon-arrow-right">
                <el-breadcrumb-item>首页</el-breadcrumb-item>
                <el-breadcrumb-item>活动印花</el-breadcrumb-item>
                <el-breadcrumb-item>详情</el-breadcrumb-item>
                <el-button class="fr return" type="info" @click="ret()">返回</el-button>
            </el-breadcrumb>
        </div>
        <div class="picBox">
            <!-- <el-row>
                <el-col :span="5" v-for="(item,i) in picDetailList" :key="i">
                    <div v-viewer class="images clearfix">
                        <img :src="'http://47.98.146.185/uploads'+item" class="image">
                    </div>
                </el-col>
            </el-row> -->

            <div v-viewer class="images clearfix">
                <template v-for="image in picDetailList">
                    <img :src="url+image" class="image" :key="image">
                </template>
            </div>
        </div>

    </div>
</template>

<script>
    import Vue from 'vue'
    import 'viewerjs/dist/viewer.css'
    import Viewer from 'v-viewer'
    Vue.use(Viewer, {
        defaultOptions: {
            zIndex: 9999
        }
    })

    import { getActivityImgsById } from '../api/api.js'
    export default {
        name: 'picDetail',
        created() {
            let id = this.$route.query.id;
            getActivityImgsById({ id: id }).then(res => {
                this.picDetailList = res.data.data.companyNewsImg.split(',')
            });
        },
        data() {
            return {
                url: this.GLOBAL.picURL,
                picDetailList: []
            }
        },
        methods: {
            ret() {
                this.$router.push({ path: '/activity' })
            }
        }
    }
</script>

<style scoped>
    .title {
        width: 70%;
        padding: 2% 15%;
        background-color: #2e324f;
        color: #fff;
        position: relative;
    }

    .picBox {
        width: 70%;
        padding: 4% 15%;
        background-color: #f5f5f5;

    }

    .images {
        /* display: flex; */
        background-color: #fff;
    }

    .images img {
        display: inline-block;
        width: 21%;
        height: 200px;
        margin: 2%;
    }

    .return {
        position: absolute;
        top: 20px;
        right: 200px;
    }
</style>



// WEBPACK FOOTER //
// src/components/picDetail.vue